module.exports = __webpack_public_path__ + "img/melissa-filtro.16e4552c.png";